import React, { useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "antd";
import { CiSaveDown1 } from "react-icons/ci";

const ExcelDownloader = ({ data }) => {
  // Function to handle Excel download
  const downloadExcel = () => {
    // Data starts from row 4 to leave space for complex headers
    const info = [
      ...[...data]?.reverse()?.map((el, i) => {
        return [
          i + 1,
          el?.organization,
          el?.ticket?.ticket,
          el?.ticket?.date?.split("T")[0],
          el?.name,
          el?.INN,
          el?.believer?.id,
          el?.believer?.name,
          el?.ykx?.date?.split("T")[0],
          el?.ykx?.ykx,
          el?.product,
          "тн",
          el?.tonna,
          el?.price,
          (el?.price / el?.tonna).toFixed(2),
          el?.customer_name,
        ];
      }),

      // Add more data rows as needed
    ];

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet([
      ["", "", "", "", "", "", "", ""], // Empty row for spacing
      ["", "", "", "", "", "", "", ""], // Empty row for spacing
      // [
      //   "",
      //   "",
      //   "ЎзРТХБ шартномаси",
      //   "",
      //   "",
      //   "",
      //   "Ишонч ваколати", // 7
      //   "Махсулот транспорт юк хати",
      //   "Чиким килинган махсулот",
      // ], // Complex header row 1
      [
        "№",
        "Ваколатли омбор ёки шахобча",
        "Шартнома №",
        "Санаси",
        "Сотиб олувчи",
        "СТИР",
        "№",
        "Ишонч ваколати",
        "Санаси",
        "№",
        "Номи",
        "улч. Бирлиги",
        "Микдори",
        "Умумий киймати",
        "Biriktirilgan",
      ], // Header row 2
      ...info, // Data rows
    ]);

    // Define merged cells
    // ws["!merges"] = [
    //   { s: { r: 2, c: 2 }, e: { r: 2, c: 3 } }, // Merge 'Ишонч ваколати' over columns C and D
    //   { s: { r: 2, c: 6 }, e: { r: 2, c: 7 } }, // Merge 'Чиким қилинган махсулот' over columns G and H
    // ];

    // Adjust column widths for better readability
    // ws["!cols"] = [
    //   { wch: 15 }, // Тел
    //   { wch: 20 }, // Каерга берилгани
    //   { wch: 25 }, // Кимга берилгани
    //   { wch: 20 }, // Йул варакаси ракaми
    //   { wch: 15 }, // АВТО
    //   { wch: 20 }, // ҲАЙДОВЧИ
    //   { wch: 20 }, // Номи
    // ];

    // Apply font style to the entire sheet
    const range = XLSX.utils.decode_range(ws["!ref"]); // Get the range of the sheet
    for (let R = range.s.r; R <= range.e.r; ++R) {
      // Loop through rows
      for (let C = range.s.c; C <= range.e.c; ++C) {
        // Loop through columns
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);

        if (!ws[cell_ref]) continue; // Skip if cell is undefined

        ws[cell_ref].s = {
          font: {
            name: "Arial Cyr", // Apply Calibri font
            sz: 9, // Font size 12
            color: { rgb: "000000" }, // Dark grey text
          },
          alignment: {
            horizontal: "center", // Center horizontally
            vertical: "center", // Center vertically
          },
        };
      }
    }

    // Create workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate buffer and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "complex_headers.xlsx");
  };

  return (
    <Button
      onClick={downloadExcel}
      icon={<CiSaveDown1 />}
      className="rounded-xl fixed bottom-[15%] right-[2.5%] z-30 bg-white"
    ></Button>
  );
};

export default ExcelDownloader;
